<template>
  <div class="projectDetails">
    <header-view :tabsign='1'></header-view>
    <div class="body w12 min-h">
		<div class="toptitle">
			<div class="left_c">
				<div class="redcon"></div>
				<span>公益项目</span>
			</div>
			<div class="right_c">

			</div>
		</div>
      <!-- <div class="boxtitle">
        <titleview title="捐助项目" color="#E61F26" class="left"></titleview>
      </div> -->
    <div class="noticeDetailstitle">{{ Institutional.title }}</div>
    <!--  <div class="subtitle">
      <span>{{ "来源：" + Institutional.createBy }}</span>
      <span>{{ " 发布时间：" + Institutional.sendTime }}</span>
    </div> -->
    <div class="msg">
      <div v-html="Institutional.conent"></div>
    </div>
	<div class="bot" v-if="reportList.length > 0">
		<div class="bot-t">
			<span class="bot-label">项目反馈：</span>
		</div>
		<div class="msg">
			<div class="ranktable">
				<table>
					<th style="text-align: center;width: 20%;">反馈时间</th>
					<th style="text-align: center;">反馈名称</th>
					<th style="text-align: center;width: 10%">操作</th>
					<template v-for="(item, index) in reportList">
						<tr @click="toShowRemark(item,index)">
							<td>
								<label>{{ item.reportTime || '' }}</label>
							</td>
							<td style="text-align: left;padding-left: 10px">
								<label>{{ item.reportTitle || '' }}</label>
							</td>
							<td>
								<label>查看详情</label>
							</td>
							<!-- <td>
								  <label v-if="item.thpDonationActivity != undefined">{{ item.thpDonationActivity.tip }}</label>
							</td> -->
							<!-- <td>{{ item.thpDonationActivity.endDate }}</td>
							<td>{{ item.thpDonationActivity.introduction }}</td> -->
						</tr>
						<tr v-if="item.showRemark">
							<td colspan="3" style="text-align: left;padding:0 10px">
								<div v-html="item.reportRemark"></div>
							</td>
						</tr>
					</template>
				</table>
			</div>
		</div>
	</div>
    <div class="bot" v-if="Institutional.trackReport">
		  <div class="bot-t">
			  <span class="bot-label">执行报告：</span>
		  </div>
		  <div class="msg">
			<div v-html="Institutional.trackReport"></div>
		  </div>
	  </div>
	  <!-- <div class="bot" v-if="Institutional.tip">
		  <span class="bot-t">
			  <span class="bot-label">温馨提示：</span>{{Institutional.tip}}
		  </span>

	  </div>		 -->

      <div class="image hand" @click="choice" v-if="ifshow">
        <img class="imgcenter" src="../../assets/newimg/hxjz.png" alt="" />
        <div class="text">我要捐款</div>
      </div>

	  <div class="filecon" v-if="Institutional.fileId">
		  <div class="filecar">
			  <!-- <img class="imgcon" src="../../assets/newimg/download.png" alt="" /> -->
			  <div class="filebtn" @click="downloadbtn">下载附件</div>
		  </div>
	  </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "Institutional",

  data: function() {
    return {
      Institutional: "",
		reportList:[],
      query: "",

	  ifshow:false,

    };
  },
  created() {
    this.query = this.$route.query;
	this.init();
  },
  mounted() {},
  methods: {
    init() {
      var that = this;
      this.httpPut("web/thpDonationActivity/getById", {
        id: this.query.id
      }).then(res => {
		if(res.success){
			that.Institutional = res.result;

			if(res.result.donationState == 1){
				that.ifshow = true;
			}else{
				that.ifshow = false;
			}

			that.reportList = that.Institutional.reportList || [];
			if(that.reportList.length>0){
				for(var i = 0;i<that.reportList.length;i++){
					that.reportList[i].showRemark = false;
				}
			}

		}
      });

	  window.pageYOffset = 0;
	  document.documentElement.scrollTop = 0;
	  document.body.scrollTop = 0;

    },
    choice() {
       this.$router.push({ path: "/payment?id=" + this.query.id +"&title="+this.Institutional.title});
    },
	downloadbtn(){
		window.location.href = this.getFileAccessHttpUrl(this.Institutional.fileId);
	},
  	toShowRemark(item,index){
		item.showRemark = !item.showRemark;
		this.$set(this.reportList, index, item);

		for (var i = 0;i<this.reportList.length;i++){
			if(i != index){
				let otherItem = this.reportList[i];
				otherItem.showRemark = false;
				this.$set(this.reportList, i, otherItem);
			}
		}

    }

  }
};
</script>
<style scoped lang="scss">
.msg{
  font-size: 16px!important;
  line-height: 30px!important;
}
.projectDetails {
  width: 100%;
  position: relative;
  .bot{
    font-size: 24px;
    padding-bottom: 30px;
    .bot-t{
      padding-bottom: 5px;border-bottom: 2px solid #E61F26;
      margin-bottom: 20px;
      color: #E61F26;
    }
    .bot-label{
      font-weight:bold;
    }
  }
  .body {
    background: #ffffff;
    margin: 120px auto 10px;
    overflow: hidden;
	.toptitle{
		height: 60px;
		border-bottom: 1px solid #ededed;
		display: flex;
		align-items: center;
		justify-content: space-between;
		.left_c{
			display: flex;
			align-items: center;
			.redcon{
				width: 5px;
				height: 20px;
				background: #E70012;
				margin-right: 20px;
			}
			font-size: 25px;
			font-weight: 400;
			color: #E61F26;
		}
	}
    .noticeDetailstitle {
      margin-bottom: 17px;
      margin-top: 17px;
      font-size: 28px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }
    .subtitle {
      text-align: center;
      margin-top:21px;
      font-size:14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      span {
        display: inline-block;
        margin-right: 40px;
        margin-bottom: 45px;
      }
    }
    .msg {
      margin: 0 auto;
    }
    .image {
      width: 112px;
      height: 79px;
      margin: 20px auto 100px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .text {
        font-size:13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        position: absolute;
        width: 100%;
        left: 0;
        text-align: center;
        bottom:8px;
      }
    }
  }

  .filecon{
	  margin-top: 80px;
    margin-bottom: 50px;
	  display: flex;
	  cursor: pointer;
	  .filecar{
		  display: flex;
		  justify-content: center;
		  .imgcon{
			  height: 30px;
			  width: 40px;
		  }
		  .filebtn{
		  		color: #1890ff;
		  }
	  }

  }

	.ranktable{
		margin-top: 20px;
		border: 1px solid #F4F4F4;
		width: 100%;
		margin-bottom: 60px;
		table {
			width: 100%;
			line-height:54px;
			border-collapse: collapse;
			font-size: 16px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #1b1b1b;
			th,td{
				//   box-shadow: 0px 0px 1px #cccccc;
				border: 1px solid #eeeeee;
				box-sizing: border-box;
			}
			th {
				background: #F9F9F9;
			}
			tr {
				color: #666666;
				background: #ffffff;
				cursor: pointer;
				td ,label{
					text-align: center;
					cursor: pointer;
				}
				.act {
					color: #e61f26;
				}

				td:last-child {
					//   border: none;
				}
			}
			tr:last-child {
				// border: none;
			}
		}
	}


}

</style>
